export const normalizeApiBase = (raw) =>
  String(raw)
    .trim()
    .replace(/\/api(\/v1)?\/?$/, '') + '/api/v1';

export const getApiBaseUrl = () => {
  const envUrl = process.env.REACT_APP_API_URL;
  if (!envUrl || !String(envUrl).trim()) {
    if (process.env.NODE_ENV === 'development') {
      return 'http://localhost:5000/api/v1';
    }
    if (process.env.NODE_ENV === 'test') {
      return 'http://localhost:5000/api/v1';
    }
    throw new Error('REACT_APP_API_URL must be set at build time');
  }
  return normalizeApiBase(envUrl);
};

export const getPlayApiBaseUrl = () => {
  const base = getApiBaseUrl().replace(/\/api(\/v1)?\/?$/, '');
  return `${base}/api/v1/play`;
};
